// components/meeting/AttentionSummary.jsx
//
// Reconstructed: imported by MeetingApprovalGate.jsx and
// MeetingApprovalsPanel.jsx (both as `<AttentionSummary attention={...} />`)
// but never actually existed anywhere in git history on any branch -- a
// pre-existing gap, unrelated to whatever else landed in this merge, just
// newly surfaced by a full production build (CRA's dev server compiles
// lazily and can miss a module nothing has forced it to touch yet).
//
// The only field either caller reads off `attention` elsewhere in the same
// files is `attention.confidence` (see doc.attention?.confidence ??
// doc.capture_confidence). There's no evidence anywhere in the codebase of
// what other fields this object may carry (no matching backend schema, no
// other reader), so this renders only what's confirmed rather than
// inventing a shape for fields nothing proves exist. If the original
// component showed more (e.g. flagged reasons), that's not restored here --
// there was nothing to reconstruct it from.
//
// Backend note: as of the current meeting-pipeline backend, no commitment
// or concern document actually carries an `attention` object -- this stays
// inert (renders null) until that ships. The threshold below matches
// MeetingApprovalGate's own confTone() (same file, same confidence value
// via doc.attention?.confidence ?? doc.capture_confidence) rather than an
// independent number, so the two don't disagree about the same value once
// `attention` does start arriving.

import { T } from '../project-register/shared.jsx';

const LOW_CONFIDENCE_THRESHOLD = 0.6;

export default function AttentionSummary({ attention }) {
  if (!attention) return null;

  const { confidence } = attention;
  if (confidence === null || confidence === undefined) return null;

  const pct = Math.round(confidence * 100);
  const isLow = confidence < LOW_CONFIDENCE_THRESHOLD;

  return (
    <span
      className="inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[10px] leading-4"
      style={{
        color: isLow ? T.warn : T.textSec,
        background: isLow ? T.warnBg : 'rgba(209,209,199,0.08)',
        border: `1px solid ${isLow ? T.warn : T.br}`,
      }}
      title="Extraction confidence"
    >
      {isLow ? '⚠ ' : ''}
      {pct}% confidence
    </span>
  );
}
